<template>
    <div>
        <div class="container container-mob" >
            <b-button variant="btn" @click="$router.go(-1)" v-b-tooltip.hover title="Назад" class="mr-2">
                <img width="40px" src="/static/images/icons/left-arrow.svg">
            </b-button>
        </div>
        <div class="container">
            <b-carousel
                    id="carousel-1"
                    v-model="slide"
                    :interval="4000"
                    controls
                    indicators
                    background="#ababab"
                    :img-height="380"
                    class="private_corousel"
                    style="text-shadow: 1px 1px 2px #333;"
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
            >
                <!-- Slides with custom text -->
                <b-carousel-slide v-if="!photos.length"  img-src="/static/images/no_image.jpg"  ></b-carousel-slide>

                <b-carousel-slide v-else  v-for="ph in photos" :key="ph.id" :img-src="'/static/uploads/'+ph.photo"></b-carousel-slide>

            </b-carousel>
        </div>
        <div class="container pt-2">
            <div class="row ">
                <div class="text-center col-lg-12">
                    <h2 class="font-weight-bold">{{school['name_'+selectedLocale.suffix.toLowerCase()]}}</h2>
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.city')}}</b>
                </div>
                <div class="col-6">
                    {{school['city_'+selectedLocale.suffix.toLowerCase()]}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.district')}}</b>
                </div>
                <div class="col-6">
                    {{school['region_'+selectedLocale.suffix.toLowerCase()]}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.address')}}</b>
                </div>
                <div class="col-6">
                    {{school['address_'+selectedLocale.suffix.toLowerCase()]}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.established')}}</b>
                </div>
                <div class="col-6">
                    {{school.createDate}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.admission_terms')}}</b>
                </div>
                <div class="col-6" v-html="school['required_'+selectedLocale.suffix.toLowerCase()]"></div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.training_duration')}}</b>
                </div>
                <div class="col-6">
                    {{school.duration}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.language_learning')}}</b>
                </div>
                <div class="col-6">
                    {{school.langs}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.specialization')}}</b>
                </div>
                <div class="col-6">
                    {{school['specialize_'+selectedLocale.suffix.toLowerCase()]}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.local_teachers')}}</b>
                </div>
                <div class="col-6">
                    {{school.teachersLocal}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.foreign_teachers')}}</b>
                </div>
                <div class="col-6">
                    {{school.teachersForeign}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.schoolbook')}}</b>
                </div>
                <div class="col-6">
                    {{$t('message.status_'+school.schoolbook)}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.food')}}</b>
                </div>
                <div class="col-6">
                    {{$t('message.status_'+school.food)}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.extraClasses')}}</b>
                </div>
                <div class="col-6" v-html="school['extraClasses_'+selectedLocale.suffix.toLowerCase()]">
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.sport_ground')}}</b>
                </div>
                <div class="col-6">
                    {{$t('message.status_'+school.sportField)}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.security')}}</b>
                </div>
                <div class="col-6">
                    {{$t('message.status_'+school.security)}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.transport')}}</b>
                </div>
                <div class="col-6">
                    {{$t('message.status_'+school.transport)}}

                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.contact_number')}}</b>
                </div>
                <div class="col-6">
                    {{school.contacts}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.email')}}</b>
                </div>
                <div class="col-6">
                    {{school.email}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.website')}}</b>
                </div>
                <div class="col-6">
                    {{school.website}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.school_hallmark')}}</b>
                </div>
                <div class="col-6" v-html="school['difference_'+selectedLocale.suffix.toLowerCase()]"></div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.payment_for_month')}}</b>
                </div>
                <div class="col-6">
                    {{school.price}}
                </div>
            </div>
            <hr/>
            <div class="row ">
                <div class="col-6">
                    <b>{{$t('message.discount')}} </b>
                </div>
                <div class="col-6">
                    {{school.discount}}
                </div>
            </div>
        </div>
        <div class="container mt-5 yandex-iframe" >
            <div v-html="school.map"></div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import {getPrivateSchoolsId} from '../api/index'

    export default {
        name: 'privet-schools',
        data() {
            return {
                slide: 0,
                sliding: null,
                school: {},
                photos: []
            }
        },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        mounted() {
            this.getData()
        },
        methods: {
            onSlideStart() {
                this.sliding = true
            },
            onSlideEnd() {
                this.sliding = false
            },
            getData() {
                getPrivateSchoolsId(  this.$route.params.id).then(res => {
                    this.school = (res.data.school.length) ? res.data.school[0] : {}
                    this.photos = res.data.photos
                })
            }
        }
    }
</script>

<style>
.private_corousel .carousel-item {
    max-height: 480px !important;
}
.private_corousel img {
    vertical-align: middle !important;
}
.yandex-iframe iframe {
    width: 100% !important;
    height: 294px !important;
}
.container-mob {
    padding-top: 100px;
    display: flex;
}
</style>
